import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { Box, Button, Modal } from "@mui/material";
import "./Signin.css";
import loginImage from '../common/images/login.png';
import ImageBox from "../common/ImageBox";

export const style = {
    borderRadius: "5px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    padding: "20px !important",
    bgcolor: "background.paper",
    boxShadow: 24,
    maxHeight: "40%",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  };
function SignIn()  {
    const { loginWithRedirect } = useAuth0();
    const navigate = useNavigate()
    const [openModal, setOpenModal] = React.useState(false);
    const [errMsg, setErrMsg]= React.useState("");

    useEffect(()=>{
        const queryParams = new URLSearchParams(window.location.search);
        const error = queryParams && queryParams.get('error');
        const errDesc = queryParams && queryParams.get('error_description');

        if(error && error == "access_denied"){
            setErrMsg(decodeURIComponent(errDesc));
            setOpenModal(true);
        }
    },[])
    

    const onClickNext = async () => {
        await loginWithRedirect({
          appState: {
            returnTo: "/home"
          },
        });
    }; 

     const handleClose = () =>{
         setOpenModal(false);         
         navigate("/");
     }

    return(
        
        <Grid container className="forgot-pwd-container">
            <Grid item xs={7}>
            <ImageBox myclass="commonImage" imageUrl={loginImage}></ImageBox>
            </Grid>
            
            <Grid item xs={5}>
                <div className="forgot-pwd-details">
                    <h2>Welcome to Fa$tlink</h2>
                    <span>A unique online solution that helps Care Facilities manage residents funds.</span>
                        
                         
                    <Grid container>
                        <Grid item xs={8}>
                            <Button variant="contained" className="next-btn" onClick={onClickNext}>Login</Button> 
                        </Grid>                          
                    </Grid> 
            <Modal open={openModal} onClose={() => handleClose()}>
          <>
              <Box sx={style}>
              {/* <CancelOutlinedIcon style={{color: "red", width:"30px", height:"30px"}}/>                 */}
                <p style={{textAlign:"center", align:"center"}}>
                  {errMsg}
                </p>
                <Button
                  id="modal-userlogin-btn"
                  variant="contained"
                  onClick={handleClose}
                >
                  Close
                </Button>
              </Box>
          </>
        </Modal>
                </div>     
            </Grid>                              
        </Grid>
        
    )
}

export default SignIn;